import ChangePlan from "@/components/ChangePlan/ChangePlan";

const ChangePlanPage: React.FC = () => {
  return <ChangePlan />;
};

export default ChangePlanPage;
